/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AppAuthMain_session$ref = any;
type MyPortalSessionThemeProvider_session$ref = any;
export type routePropsAppAuthMain_QueryVariables = {||};
export type routePropsAppAuthMain_QueryResponse = {|
  +my_portal_session: ?{|
    +id: string,
    +is_session_ready: boolean,
    +sign_in_auth_invalid_path: ?string,
    +$fragmentRefs: MyPortalSessionThemeProvider_session$ref & AppAuthMain_session$ref,
  |}
|};
export type routePropsAppAuthMain_Query = {|
  variables: routePropsAppAuthMain_QueryVariables,
  response: routePropsAppAuthMain_QueryResponse,
|};
*/


/*
query routePropsAppAuthMain_Query {
  my_portal_session {
    id
    is_session_ready
    sign_in_auth_invalid_path
    ...MyPortalSessionThemeProvider_session
    ...AppAuthMain_session
  }
}

fragment AppAuthLayout_session on MyPortal__Session {
  id
  current_locale
  supported_languages {
    locale
    label
  }
  brand {
    company_name
    logo_url
    privacy_url
  }
  portal_person {
    id
    email_address
    internal_career_sites_url
  }
  signout_url
  sign_out_label: i18n(key: "global.actions.sign_out")
  navigation_items {
    key
  }
  label_privacy_policy_link: i18n_config_t(key: "myportal.config.footer.privacy_policy_link")
  referrals_link_to_career_site_label: i18n_config_t(key: "myportal.config.referrals.link_to_career_site_label")
  ...AppNavigation_session
}

fragment AppAuthMain_session on MyPortal__Session {
  portal_person {
    id
  }
  signout_url
  ...MyPortalSessionThemeProvider_session
  ...AppAuthLayout_session
  ...AuthFormProvider_session
  label_close: i18n(key: "global.actions.close")
}

fragment AppNavigation_session on MyPortal__Session {
  id
  navigation_items {
    url
    label
    key
    badge_content
    icon {
      ...IconPresenter_icon
    }
    sub_navigation {
      url
      label
      key
      badge_content
      icon {
        ...IconPresenter_icon
      }
    }
  }
}

fragment AuthFormProvider_session on MyPortal__Session {
  id
  auth_sent
  can_resend_auth
  authorization_unauthorized_page_description_label
  authorization_unauthorized_page_heading: i18n_config_t(key: "myportal.config.authorization.unauthorized.page_heading")
  authorization_unauthorized_have_not_recieved_an_email: i18n_config_t(key: "myportal.config.authorization.unauthorized.have_not_recieved_an_email")
  authorization_unauthorized_actions_send_again: i18n_config_t(key: "myportal.config.authorization.unauthorized.actions.send_again")
}

fragment BrandThemeProvider_brand on PublicBrand {
  is_rtl
  font_family
  background_color
  error_color
  secondary_color_text
  secondary_color
  alt_color_text
  alt_color
  primary_color
  is_dark_mode
}

fragment IconPresenter_icon on CommonIconPresenter {
  type
  name
}

fragment MyPortalSessionThemeProvider_session on MyPortal__Session {
  brand {
    ...BrandThemeProvider_brand
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "is_session_ready",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sign_in_auth_invalid_path",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "badge_content",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "CommonIconPresenter",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "routePropsAppAuthMain_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MyPortal__Session",
        "kind": "LinkedField",
        "name": "my_portal_session",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MyPortalSessionThemeProvider_session"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AppAuthMain_session"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "routePropsAppAuthMain_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MyPortal__Session",
        "kind": "LinkedField",
        "name": "my_portal_session",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PublicBrand",
            "kind": "LinkedField",
            "name": "brand",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "is_rtl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "font_family",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "background_color",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "error_color",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "secondary_color_text",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "secondary_color",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "alt_color_text",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "alt_color",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primary_color",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "is_dark_mode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "company_name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "logo_url",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "privacy_url",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MyPortal__PortalPerson",
            "kind": "LinkedField",
            "name": "portal_person",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email_address",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "internal_career_sites_url",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "signout_url",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "current_locale",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MyPortal__LanguageInfo",
            "kind": "LinkedField",
            "name": "supported_languages",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "locale",
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "sign_out_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "global.actions.sign_out"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n",
            "storageKey": "i18n(key:\"global.actions.sign_out\")"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NavigationItem",
            "kind": "LinkedField",
            "name": "navigation_items",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v3/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NavigationItem",
                "kind": "LinkedField",
                "name": "sub_navigation",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "label_privacy_policy_link",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.footer.privacy_policy_link"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.footer.privacy_policy_link\")"
          },
          {
            "alias": "referrals_link_to_career_site_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.referrals.link_to_career_site_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.referrals.link_to_career_site_label\")"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "auth_sent",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "can_resend_auth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "authorization_unauthorized_page_description_label",
            "storageKey": null
          },
          {
            "alias": "authorization_unauthorized_page_heading",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.authorization.unauthorized.page_heading"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.authorization.unauthorized.page_heading\")"
          },
          {
            "alias": "authorization_unauthorized_have_not_recieved_an_email",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.authorization.unauthorized.have_not_recieved_an_email"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.authorization.unauthorized.have_not_recieved_an_email\")"
          },
          {
            "alias": "authorization_unauthorized_actions_send_again",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.authorization.unauthorized.actions.send_again"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.authorization.unauthorized.actions.send_again\")"
          },
          {
            "alias": "label_close",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "global.actions.close"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n",
            "storageKey": "i18n(key:\"global.actions.close\")"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1bfff31d92e528832dc51636cff46767",
    "id": null,
    "metadata": {},
    "name": "routePropsAppAuthMain_Query",
    "operationKind": "query",
    "text": "query routePropsAppAuthMain_Query {\n  my_portal_session {\n    id\n    is_session_ready\n    sign_in_auth_invalid_path\n    ...MyPortalSessionThemeProvider_session\n    ...AppAuthMain_session\n  }\n}\n\nfragment AppAuthLayout_session on MyPortal__Session {\n  id\n  current_locale\n  supported_languages {\n    locale\n    label\n  }\n  brand {\n    company_name\n    logo_url\n    privacy_url\n  }\n  portal_person {\n    id\n    email_address\n    internal_career_sites_url\n  }\n  signout_url\n  sign_out_label: i18n(key: \"global.actions.sign_out\")\n  navigation_items {\n    key\n  }\n  label_privacy_policy_link: i18n_config_t(key: \"myportal.config.footer.privacy_policy_link\")\n  referrals_link_to_career_site_label: i18n_config_t(key: \"myportal.config.referrals.link_to_career_site_label\")\n  ...AppNavigation_session\n}\n\nfragment AppAuthMain_session on MyPortal__Session {\n  portal_person {\n    id\n  }\n  signout_url\n  ...MyPortalSessionThemeProvider_session\n  ...AppAuthLayout_session\n  ...AuthFormProvider_session\n  label_close: i18n(key: \"global.actions.close\")\n}\n\nfragment AppNavigation_session on MyPortal__Session {\n  id\n  navigation_items {\n    url\n    label\n    key\n    badge_content\n    icon {\n      ...IconPresenter_icon\n    }\n    sub_navigation {\n      url\n      label\n      key\n      badge_content\n      icon {\n        ...IconPresenter_icon\n      }\n    }\n  }\n}\n\nfragment AuthFormProvider_session on MyPortal__Session {\n  id\n  auth_sent\n  can_resend_auth\n  authorization_unauthorized_page_description_label\n  authorization_unauthorized_page_heading: i18n_config_t(key: \"myportal.config.authorization.unauthorized.page_heading\")\n  authorization_unauthorized_have_not_recieved_an_email: i18n_config_t(key: \"myportal.config.authorization.unauthorized.have_not_recieved_an_email\")\n  authorization_unauthorized_actions_send_again: i18n_config_t(key: \"myportal.config.authorization.unauthorized.actions.send_again\")\n}\n\nfragment BrandThemeProvider_brand on PublicBrand {\n  is_rtl\n  font_family\n  background_color\n  error_color\n  secondary_color_text\n  secondary_color\n  alt_color_text\n  alt_color\n  primary_color\n  is_dark_mode\n}\n\nfragment IconPresenter_icon on CommonIconPresenter {\n  type\n  name\n}\n\nfragment MyPortalSessionThemeProvider_session on MyPortal__Session {\n  brand {\n    ...BrandThemeProvider_brand\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '50cf80ac6357395181e1c553db5b9c8c';

module.exports = node;
